import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { getFranchiseById, getPostcodeCountryByFranchiseId, getSubjectDefaultRateHistory, getSubjectThresholdHistory, getSubjectsByFranchise } from '@app/services/franchise';
import { Form } from 'react-bootstrap';
import moment from 'moment';
import { useSelector } from 'react-redux';
import CurrencyFormat from 'react-currency-format';
import UpdateSubjectDefaultRateModal from './UpdateSubjectDefaultRateModal';
import UpdateThresholdModal from './UpdateThresholdModal';
import SubjectHistoryModal from './SubjectHistoryModal';
import { useDecodedParam } from '@app/hooks/useDecodedParam';
import { encodeId } from '@app/helpers/base64url';

const ViewFranchise = () => {

    const id = useDecodedParam('id', '/franchise');
    let obj: any = {}
    const franchiseTypes = [{value:'in-house', label:'In-house'}, {value:'company', label:'Limited Company'}, {value:'partnership', label:'Partnership'}, {value:'sole_trader', label:'Sole Trader'}];
    const franchiseStatus = [{value:'active', label:'Active'}, {value:'inactive', label:'Inactive'}, {value:'on_hold', label:'On Hold'}];
    const [isLoading, setLoading] = useState(false);
    const [franchise, setFranchiseData] = useState(obj);
    const [subjects, setSubjects] = useState([]);
    const [currency, setCurrency] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [showUpdateDefaultRate, setShowUpdateDefaultRate] = useState(false);
    const [subjectName, setSubjectName] = useState('');
    const [subDefaultRateHistory, setSubDefaultRateHistory] = useState([]);
    const [subjectThresholdHistory, setSubjectThresholdHistory] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [historyType, setHistoryType] = useState('');
    const handleHistoryClose = () => setShowHistory(false);
    const handleUpdateDefaultRateClose = () => setShowUpdateDefaultRate(false);
    const [defaultRatePayload, setSubjectDefaultRatePayload] = useState({});
    const [showUpdateThreshold, setShowUpdateThreshold] = useState(false);
    const handleUpdateThresholdClose = () => setShowUpdateThreshold(false);
    const [subjectThresholdPayload, setSubjectThresholdPayload] = useState({franchise_id: id, subject: {}});
    const canAccess = useSelector((state: any) => state.auth.permissions.franchise);
    const navigate = useNavigate();
    
    useEffect(() => {
        getFranchiseDetailsById(id)
        getSubjectsByFranchiseId()
        getCountryByFranchiseId(id)
    }, []);

    const getFranchiseDetailsById = async (id) => {
        try {
            setLoading(true);
            const resp = await getFranchiseById(id);
            if(resp.success === true){
                setLoading(false);
                setFranchiseData(resp.collections);
                if(resp?.collections?.franchisee !== null){
                    setSelectedUsers(resp?.collections?.franchisee.map.call(resp?.collections?.franchisee, function(user) { return user.first_name +' '+user.last_name; }).join(", "))
                }
            }else{
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
                navigate('/franchise');
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getSubjectsByFranchiseId = async () => {
        try {
            const resp = await getSubjectsByFranchise(id);
            if(resp.success === true){
                setSubjects(resp.collections);
            }else{
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getCountryByFranchiseId = async (franchiseId) => {
        try {
            const resp = await getPostcodeCountryByFranchiseId(franchiseId);
            if (resp?.success === true) {
                setCurrency(resp?.collections?.currency)
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getSubjectRateHistoryData = async (id, subjectId) => {
        try {
            const resp = await getSubjectDefaultRateHistory(id, subjectId);
            if(resp.success === true){
                setSubDefaultRateHistory(resp.collections);
            }else{
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error')
        }
    };

    const getSubjectThresholdHistoryData = async (id, subjectId) => {
        try {
            const resp = await getSubjectThresholdHistory(id, subjectId);
            if(resp.success === true){
                setSubjectThresholdHistory(resp.collections);
            }else{
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error')
        }
    };

    const handleSubDefaultRateHistory = (subject) => {
        setShowHistory(true);
        setSubjectName(subject.name + ' - Default Rate ');
        setHistoryType('default-rate');
        setSubjectThresholdHistory([]);
        getSubjectRateHistoryData(id, subject.subject_id);
    }

    const handleThresholdHistoryShow = (subject) => {
        setShowHistory(true);
        setSubjectName(subject.name + ' Print Threshold');
        setHistoryType('threshold');
        setSubDefaultRateHistory([]);
        getSubjectThresholdHistoryData(id, subject.subject_id);
    }

    const handleUpdateSubjectDefaultRate = (subject) => {
        setShowUpdateDefaultRate(true);
        setSubjectDefaultRatePayload(subject);
    }

    const handleUpdateThreshold = (subject) => {
        setShowUpdateThreshold(true);
        setSubjectName(subject.name);
        setSubjectThresholdPayload({franchise_id: id, subject: subject});
    }

  return (
    <div>
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">View Franchise</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Franchise Name </dt>
                                            <dd>{franchise.name} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Franchise Type </dt>
                                            <dd>{franchise?.type ? (franchiseTypes.find(obj => { return obj.value === franchise?.type}))?.label : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Address </dt>
                                            <dd>{franchise.address ? franchise.address : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Franchisee(s) </dt>
                                            <dd>{selectedUsers ? selectedUsers : '---'} </dd>
                                        </div>
                                    </div>
                                    {/* <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Kashflow Licence Account </dt>
                                            <dd>{franchise.kashflow_license_account ? franchise.kashflow_license_account : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Kashflow Order Account </dt>
                                            <dd>{franchise.kashflow_order_account ? franchise.kashflow_order_account : '---'}</dd>
                                        </div>
                                    </div> */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Start Date </dt>
                                            <dd>{franchise?.start_date ? moment(franchise.start_date).format('DD/MM/YYYY') : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>End Date </dt>
                                            <dd>{franchise?.end_date ? moment(franchise.end_date).format('DD/MM/YYYY') : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Effective Start Date </dt>
                                            <dd>{franchise?.effective_start_date ? moment(franchise.effective_start_date).format('DD/MM/YYYY') : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>VAT </dt>
                                            <dd>{franchise.vat ? franchise.vat : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Sort Code </dt>
                                            <dd>{franchise.sort_code ? franchise.sort_code : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Account Number </dt>
                                            <dd>{franchise.account_number ? franchise.account_number : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Phone </dt>
                                            <dd>{franchise.phone ? franchise.phone : '---'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Status </dt>
                                            <dd>{franchise?.status ? (franchiseStatus.find(obj => { return obj.value === franchise?.status}))?.label : '---'} </dd>
                                        </div>
                                    </div>
                                    { franchise.reason != null && (
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>Reason </dt>
                                                <dd>{franchise.reason ? franchise.reason : '---'}</dd>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className='row content_inner_wrap'>
                                    <div className="col-sm-12">
                                        <label>Settings</label>
                                    </div>  
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Is VAT Applicable? </dt>
                                            <dd>{franchise?.student_count_tax ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Is Student Count Mandatory? </dt>
                                            <dd>{franchise?.enabled_student_count ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Holiday Camp? </dt>
                                            <dd>{franchise?.enabled_holiday_camp ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Ad-hoc Printing? </dt>
                                            <dd>{franchise?.enabled_adhoc_printing ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Handbook Printing? </dt>
                                            <dd>{franchise?.enabled_handbook_print ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Student Management? </dt>
                                            <dd>{franchise?.enabled_manage_students ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Recurring Invoices? </dt>
                                            <dd>{franchise?.enabled_recurring_invoice ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Material Orders? </dt>
                                            <dd>{franchise?.enabled_material_orders ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Review of Session Notes? </dt>
                                            <dd>{franchise?.enabled_review_session_notes ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <dt>Enable Local Printing? </dt>
                                            <dd>{franchise?.student_local_printing ? 'Yes' : 'No'} </dd>
                                        </div>
                                    </div>
                                    {franchise?.student_local_printing && (
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>Local Printing Mode </dt>
                                                <dd>{franchise?.local_printing_mode === 'worksheet_paid' ? 'Worksheet Paid' : 'Worksheet Inclusive'} </dd>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="card-footer">
                            { canAccess?.edit && 
                                <Link className="btn btn-primary mr-2" to={`/franchise/edit/${encodeId(id)}`}>Edit</Link>
                            }
                                <Link className="btn btn-default" to='/franchise'>Close</Link>
                            </div>
                        </div>
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">Manage Subjects</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {subjects?.length > 0 && (
                                        <>
                                        <div className='col-md-6 my-2'>
                                            <h6><b>Franchise Subjects</b></h6>
                                        </div>
                                        <div className='col-md-4 my-2'>
                                            <h6><b>Franchise Default Rates For Student</b></h6>
                                        </div>
                                        {franchise?.student_local_printing && franchise?.local_printing_mode === 'worksheet_inclusive' && (
                                            <div className='col-md-2 my-2'>
                                                <h6><b>Monthly Print Threshold Per Student</b></h6>
                                            </div>
                                        )}
                                        <div className="col-md-6">
                                            <table className="table table-bordered" id="client_id_table">
                                                <tbody>
                                                    <tr className='text-center' style={{height: '60px', verticalAlign: 'middle'}}>
                                                        <th>Subject</th>
                                                        <th>Status</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Rate (Payable to FCL)</th>
                                                        {/* <th>History</th> */}
                                                    </tr>
                                                    {subjects?.length > 0  && subjects.map((subject) => (
                                                        <tr key={subject.subject_id}>
                                                            <td>{ subject.name }</td>
                                                            <td>
                                                                    { subject.status === 'active' ? 
                                                                    <span className="badge bg-success">Active</span> 
                                                                    : <span className="capitalize badge bg-danger">{subject.status.charAt(0).toUpperCase() + subject.status.slice(1)}</span> }
                                                            </td>
                                                            <td width={100}>{ (subject.start_date != null) ? moment(subject.start_date).format('DD-MM-YYYY') : 'N/A'}</td>
                                                            <td width={100}>{ (subject.end_date != null) ? moment(subject.end_date).format('DD-MM-YYYY') : 'N/A'}</td>
                                                            <td className=''>
                                                                { subject?.rate ? <CurrencyFormat value={ subject?.rate } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={subject?.rate_type === 'fixed' ? '£ ' : ''} suffix={subject?.rate_type === 'percentage' ? ' %' : ''} /> : '---' }
                                                            </td>
                                                            {/* <td className='text-center'><a href="#" onClick={ (e) => handleHistoryShow(subject) } data-toggle="tooltip" title="History"> <i className="fas fa-history mr-2" /> </a> </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="col-md-4">
                                            <table className="table table-bordered" id="client_id_table">
                                                <tbody>
                                                    <tr className='text-center' style={{height: '60px', verticalAlign: 'middle'}}>
                                                        <th>Default Rate (Payable by Parent)</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {subjects?.length > 0  && subjects.map((subject) => (
                                                        <tr key={subject.subject_id}>
                                                            <td className='text-center'>
                                                                { subject?.student_default_rate ? <CurrencyFormat value={ subject?.student_default_rate } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={currency + ' '} /> : '---' }
                                                            </td>
                                                            <td className='text-center'>
                                                                { subject.status === 'active' && (
                                                                    <a href="Javascript:void(0)" 
                                                                        onClick={ (e) => handleUpdateSubjectDefaultRate(subject) } 
                                                                        data-toggle="tooltip" title="Edit Default Rate"> <i className="fas fa-pen mr-2" /> </a> 
                                                                )}
                                                                <a href="Javascript:void(0)" 
                                                                    onClick={ (e) => handleSubDefaultRateHistory(subject) } 
                                                                    data-toggle="tooltip" title="Default Rate History"> <i className="fas fa-history mr-2" /> </a> 
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {franchise?.student_local_printing && franchise?.local_printing_mode === 'worksheet_inclusive' && (
                                            <div className="col-md-2">
                                                <table className="table table-bordered" id="client_id_table">
                                                    <tbody>
                                                        <tr className='text-center' style={{height: '60px', verticalAlign: 'middle'}}>
                                                            <th>Threshold</th>
                                                            {/* <th>Action</th> */}
                                                        </tr>
                                                        {subjects?.length > 0  && subjects.map((subject) => (
                                                            <tr key={subject.subject_id}>
                                                                <td className='text-center'>
                                                                    { subject?.worksheet_count_threshold !== null && subject?.worksheet_count_threshold !== undefined ? `${subject.worksheet_count_threshold} worksheets` : '---' }
                                                                </td>
                                                                {/* <td className='text-center'>
                                                                    { subject.status === 'active' && (
                                                                        <a href="Javascript:void(0)" 
                                                                            onClick={ (e) => handleUpdateThreshold(subject) } 
                                                                            data-toggle="tooltip" title="Edit Print Threshold"> <i className="fas fa-pen mr-2" /> </a> 
                                                                    )}
                                                                    <a href="Javascript:void(0)" 
                                                                        onClick={ (e) => handleThresholdHistoryShow(subject) } 
                                                                        data-toggle="tooltip" title="Print Threshold History"> <i className="fas fa-history mr-2" /> </a> 
                                                                </td> */}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        </>
                                    )}
                                    {subjects?.length == 0 && (
                                        <span style={{ color: "red", textAlign: "center" }}>There are no records to display</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UpdateSubjectDefaultRateModal
                show={showUpdateDefaultRate}
                handleClose={handleUpdateDefaultRateClose}
                payload={defaultRatePayload}
                getSubjectsByFranchiseId={getSubjectsByFranchiseId}
                currency={currency}
            />

            <UpdateThresholdModal
                show={showUpdateThreshold}
                handleClose={handleUpdateThresholdClose}
                payload={subjectThresholdPayload}
                getSubjectsByFranchiseId={getSubjectsByFranchiseId}
            />

            <SubjectHistoryModal
                show={showHistory}
                handleClose={handleHistoryClose}
                subjectName={subjectName}
                type={historyType}
                currency={currency}
                subDefaultRateHistory={subDefaultRateHistory}
                thresholdHistoryData={subjectThresholdHistory}
            />
        </section>
    </div>
  )
}

export default ViewFranchise;